import { useNavigate, useLocation, useSearch } from '@tanstack/react-router';
import { useMemo } from 'react';

export function useRouter() {
  let navigate: any = () => {};
  let location: any = { pathname: '/', searchStr: '', hash: '' };
  let search: any = {};

  try {
    navigate = useNavigate();
  } catch (e) {}

  try {
    location = useLocation();
  } catch (e) {}

  try {
    search = useSearch({ strict: false });
  } catch (e) {}

  const router = useMemo(() => {
    return {
      pathname: location.pathname,
      asPath: location.pathname + (location.searchStr ? `?${location.searchStr}` : '') + (location.hash ? `#${location.hash}` : ''),
      route: location.pathname,
      query: { ...search },
      isReady: true,
      push: (url: string | { pathname: string; query?: any }, as?: string, options?: any) => {
        const target = typeof url === 'string' ? url : url.pathname;
        return navigate({ to: target as any });
      },
      replace: (url: string | { pathname: string; query?: any }, as?: string, options?: any) => {
        const target = typeof url === 'string' ? url : url.pathname;
        return navigate({ to: target as any, replace: true });
      },
      back: () => window.history.back(),
      reload: () => window.location.reload(),
      events: {
        on: () => {},
        off: () => {},
        emit: () => {},
      },
    };
  }, [location, search, navigate]);

  return router;
}

export default useRouter;
